// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"_239xx","carImage":"_2zMz-","contentText":"_3do-W","ctaText":"_3XsaI"};